import {
  BlockListSection as BlockListSectionType,
  DetailSection as DetailSectionType,
  InlineListSection as InlineListSectionType,
  Resume,
} from '@sr/types';
import * as React from 'react';
import { sectionsFromResume } from './utils';

type Props = {
  filter: 'all' | 'detail' | 'list';
  resume: Resume;
  DetailSection: React.ComponentType<{
    section: DetailSectionType;
    currentDateString?: string | null;
  }>;
  BlockListSection: React.ComponentType<{
    section: BlockListSectionType;
  }>;
  InlineListSection: React.ComponentType<{
    section: InlineListSectionType;
  }>;
};

const Sections = ({
  filter,
  resume,
  DetailSection,
  BlockListSection,
  InlineListSection,
}: Props) => {
  const sections = sectionsFromResume(resume);
  let filteredSections: (
    | DetailSectionType
    | BlockListSectionType
    | InlineListSectionType
  )[] = [];

  if (filter === 'all') {
    filteredSections = sections;
  } else if (filter === 'detail') {
    filteredSections = sections.filter((section) => section.type === 'detail');
  } else if (filter === 'list') {
    filteredSections = sections.filter((section) => section.type !== 'detail');
  }

  return (
    <>
      {filteredSections.map((section) => {
        switch (section.type) {
          case 'detail':
            return (
              <DetailSection
                section={section}
                currentDateString={resume.currentDateString}
                key={section.sectionId}
              />
            );

          case 'inline-list':
            return (
              <InlineListSection section={section} key={section.sectionId} />
            );

          case 'block-list':
            return (
              <BlockListSection section={section} key={section.sectionId} />
            );

          default:
            console.error('Invalid section type:', section);
            return false;
        }
      })}
    </>
  );
};

export default Sections;
